module.exports = {
  "name": "master",
  "client": "Mobile spot",
  "description": "Mobile app for test",
  "validLangs": ["fr", "en"],
  "version": {
    "mainVersion": "1.5.0",
    "buildVersion": {
      "iOS": "102",
      "android": "106",
      "web": "321"
    }
  },
  "native": {
    "androidSigning": {
      "keyAlias": "mobilespotmom",
      "keyStorePassword": "jee1Uu0Hieloh7ba"
    },
    "app": "app-react",
    "name": {
      "default": "Master_D"
    },
    "id": "com.mobilespot.master.dev",
    "appleTeamId": "2BAP3P29V2",
    "playStoreUrl": ""
  },
  "undeliveredFolders": ["source", "exports"],
  "crypto": false,
  "web": {
    "url": "master.ms-dev.mobile-spot.com"
  },
  "customFileUrlScheme": "msfile",
  "relatedRepos": [{
    "src": "git@bitbucket.org:mobilespotdev/cordova.git",
    "branch": "inte/master/main",
    "postCommands": ["cd cordova && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo.git",
    "branch": "inte/master/main",
    "postCommands": ["cd mobigeo && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo-customs-master.git",
    "branch": "inte/master/main",
    "dest": "mobigeo/mobigeo-customs",
    "postCommands": ["cd mobigeo/mobigeo-customs && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/app-react.git",
    "branch": "inte/master/main"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/data-master.git",
    "branch": "inte/master/main",
    "dest": "app-react/app-customs",
    "postCommands": ["cd app-react && yarn", "cd app-react && npm run set-env dev", "cd app-react && npm run download-assets", "cd app-react && npm run download-data-files", "cd app-react && npm run update-mobigeo"]
  }]
};